import { t } from "i18next";
import { useEffect } from "react";
import { InfoMessageType } from "src/Components/InfoBar/InfoBar";
import PopupDialog from "src/SharedComponents/PopupDialog/PopupDialog";
import { useEditPaymentMethod } from "src/Utils/Hooks/Payments/useEditPaymentMethod";
import { UpgradeErrorCode } from "src/Utils/Hooks/Payments/useGetUpgradeInfo";

interface IUpgradeErrorInfo {
    code:UpgradeErrorCode;
    clinicId: string;
    setInfo: (message: string, type: InfoMessageType) => void;
    updatePageLoader: (load: boolean) => void;
    onCloseUpgradeInfo: () => void;
}

const UpgradeErrorInfo: React.FC<IUpgradeErrorInfo> = ({ code, clinicId,setInfo, updatePageLoader, onCloseUpgradeInfo}) => {

const { getEditPaymentInfo, data, loading, error } = useEditPaymentMethod();

    useEffect(() => {
        if (error !== '') {
            setInfo(error, InfoMessageType.error);
        }
    }, [error, setInfo]);

    useEffect(() => {
        updatePageLoader(loading);
    }, [loading, updatePageLoader]);

    useEffect(() => {
        if (data?.paymentMethodUpdateUrl) {
            window.open(data?.paymentMethodUpdateUrl, '_self');
        }
    }, [data]);

    const handleClick = () => {
        getEditPaymentInfo(clinicId);
    };
    
    return (
        <>
        <PopupDialog onClose={() => onCloseUpgradeInfo()} marginTop="200px" popupWidth="496px">
                    <div className="p-3">
                        <div className="row">
                            <div className="col-md-10" style={{textAlign: 'center', paddingLeft:'78px'}}>
                                <span style={{ fontWeight: '600', fontSize: '20px' }}>
                                    {t('UpgradingDetails')}
                                </span>
                            </div>
                        </div>
                        {   
                    (code === UpgradeErrorCode.TaxInfoNotFound || code === UpgradeErrorCode.CardNotFound) && 
                    <div className="row mt-4" style={{ textAlign: 'center', padding: '0 30px' }}>
                        <span>
                            <div style={{ margin: 0 }}>
                                You have currently no payment information set. Please add your 
                                <span 
                                     style={{ color: 'blue', textDecoration: 'underline', cursor: 'pointer' }}  
                                     onClick={() => { handleClick(); }}> payment information
                                </span>  before upgrading.
                            </div>
                        </span>
                    </div>
                }
       {   
                    code === UpgradeErrorCode.PaymentPending && 
                    <div className="mt-4" style={{ textAlign: 'center', padding: '0 30px 10px' }}>
                        <span style={{margin: 0 }}>
                            {t('UpgradePaymentPending')}
                        </span>
                    </div>
                }
                     </div>
        </PopupDialog>   
        
        </>
    )

};

export default UpgradeErrorInfo;